import { IonButton, IonButtons, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonLoading, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import { arrowBack, ticketOutline } from 'ionicons/icons';
import React, { useState } from 'react';
import "./Cupom.css";


type Props = {
  configuracoesCupom: any[];
  cupom: any;
  closeAction: Function;
  closeActionSimple: Function;
};

const Cupom: React.FC<Props> = (props: Props) => {

  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const loadConfiguracoesCupom = () => {

    if ((Array.isArray(props.configuracoesCupom) && props.configuracoesCupom.length === 0) || !props.configuracoesCupom) {
      return (

        <IonItem lines="none" key={"semAgenda"}>

          <IonLabel>
            <h2 style={{ "verticalAlign": "middle" }}><strong>Nenhum cupom disponível</strong></h2>
          </IonLabel>

        </IonItem>


      );
    }




    return (
      <>
        {/* The reorder gesture is disabled by default, enable it to drag and drop items */}
        {props.configuracoesCupom.map((value: any, index: any) => {

          return (
            <IonItem style={{ padding: '0px', margin: '0px' }} lines="none"
              key={"cupom" + value.id}
              button
              detail
              onClick={() => props.closeAction(value.valor, value.nome)}
            >

              <IonLabel text-wrap>
                <IonIcon size='large' icon={ticketOutline}></IonIcon>
                <b> R$ {value.valor}</b> de desconto disponível com o cupom <b>{value.nome}</b>, válido para pedidos acima de <b>R$ {value.valorMinimo}</b>.
              </IonLabel>
            </IonItem>

          )
        })}
      </>
    );
  }

  return (

    <>
      <IonHeader className="ion-no-border">
        <IonToolbar>

          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => {
              props.closeActionSimple();
            }} />
          </IonButtons>
          <IonTitle>Cupom</IonTitle>

        </IonToolbar>


      </IonHeader>

      <IonContent fullscreen={false}>

        <IonGrid>
          <IonList>
            {loadConfiguracoesCupom()}

          </IonList>
        </IonGrid>


        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />
      </IonContent>

      <IonFooter>
        {(props.cupom) && (

          <IonToolbar style={{ padding: '10px' }}>


            <IonButton
              // color="success"
              style={{ height: "46px", fontSize: "18px" }}
              onClick={async () => {
                props.closeAction();
              }}
              expand="block"
              type="submit"
            >
              Remover Cupom
            </IonButton>


          </IonToolbar>

        )}
      </IonFooter>
    </>


  );
};

export default ({ configuracoesCupom, cupom, closeAction, closeActionSimple }: { configuracoesCupom: any[], cupom: any, closeAction: Function, closeActionSimple: Function }) => (
  <Cupom configuracoesCupom={configuracoesCupom} cupom={cupom} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </Cupom>
)
